<script setup lang="ts">
import imageClassmates from '@/assets/images/social/classmates.svg'
import imageTelegram from '@/assets/images/social/telegram.svg'
import imageVk from '@/assets/images/social/vk.svg'

type Props = {
  width?: string
  height?: string
}

withDefaults(defineProps<Props>(), {
  width: '24',
  height: '24',
})

const socialNetworks = [
  {
    alt: 'Вконтакте',
    img: imageVk,
    href: 'https://vk.com/farfordostavka',
    title: 'Ресторан Farfor в VK',
  },
  {
    alt: 'Телеграм',
    img: imageTelegram,
    href: 'https://t.me/farfordostavkaTG',
    title: 'Ресторан Farfor в Telegram',
  },
  {
    alt: 'Одноклассники',
    img: imageClassmates,
    href: 'https://ok.ru/group/54320404496454',
    title: 'Ресторан Farfor в Одноклассниках',
  },
]
</script>

<template>
  <div class="social-networks" data-test-id="social-networks">
    <a
      v-for="socialNetwork in socialNetworks"
      :key="socialNetwork.href"
      :href="socialNetwork.href"
      :title="socialNetwork.title"
      target="_blank"
      data-test-id="social-link"
    >
      <nuxt-img
        class="social-networks__social-image"
        :width="width"
        :height="height"
        :src="socialNetwork.img"
        :alt="socialNetwork.alt"
        data-test-id="social-icon"
      />
    </a>
  </div>
</template>

<style scoped lang="scss">
.social-networks {
  display: flex;

  a {
    display: flex;
  }
}
</style>
